import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck, Inject, OnDestroy  } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent, DwMetaDataGridActionState,
         DwQueryHelper, DwOrmDataServiceToken, DwOrmDataService, DwMetaDataFormStateService, DwGridEvents,
         DwMetaDataFormApi, DwQueryOrder, DwQueryFieldInfo, DwGridEvent, DwEvent, DwMdLoadEventData, DwGridDeleteActionService,
         DwQueryFilterGroup, DwOperator, DwActionPreference, DwMetaDataGridApi, DwMetaDataService, DwMetaDataServiceToken,
         DwFormActionConfig, DwFormActionInterceptResult, DwInMemoryDataSource, DwFormContextMode, DwMetaDataGridPreferences, DwGridActionResult } 
         from '@devwareapps/devware-cap';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { NumbersMetaDataItemNames, RoUserProjectionAnalyzedEntity, WcUserProjectionEntity } from '../meta-data/numbers-meta-data.service';
import { AppMetaDataService, AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { Observable, Subscription, of } from 'rxjs';
import * as moment_ from 'moment';
const moment = moment_;

@DwComponent(
  {
    key: 'recent-user-projections',
    name: 'Recent User Projects',
    componentType: DwComponentType.pageComponent,
    parentItemName: [NumbersMetaDataItemNames.WcUserProjection],
    isGlobal: false,
  }
)
@Component({
  selector: 'recent-user-projections',
  styles: [`
    .up-main { height:124px; overflow-y: auto }
    .up-hdrs { font-size: 0.8rem !important; font-weight: bold !important; }
    .up-main-label { font-size: 0.875rem !important; font-weight: bold !important; }
    .up-analyzed { color: red !important;}
    .up-data { font-size: 0.8rem !important; }
  `],
  template: `<div *ngIf="projections.length > 0">
    <div class="up-main-label">Recent Projections</div>
        <div dwRow>
            <div dwCol="9" class="up-main">
                <div dwRow class="up-hdrs">
                    <div dwCol="2">Revenue</div>
                    <div dwCol="2">Cost</div>
                    <div dwCol="2">Gross Profit</div>
                    <div dwCol="3">Gross Profit Margin</div>
                    <div dwCol="3">Date Time Projected</div>
                </div>
                <div dwRow *ngFor="let i of projections" class="up-data">
                    <div dwCol="2">{{i.Revenue | number : '1.2-2'}}</div>
                    <div dwCol="2">{{i.Cost | number : '1.2-2'}}</div>
                    <div dwCol="2">{{i.Gross | number : '1.2-2'}}</div>
                    <div dwCol="3">{{i.GrossMargin | number : '1.2-2'}}%</div>
                    <div dwCol="3">{{i.DateTimeProjected + 'Z' | date:'MM/dd/yyyy, hh:mm a'}}</div>
                </div>
            </div>
            <div dwCol="3" class="up-data up-analyzed">
                Reports will take your latest<br>
                projection into account after<br>
                {{next.DateTimeUtcAnalyzed +'Z' | date:'MM/dd/yyyy, hh:mm a'}}
            </div>
        </div>
    </div>
`
})
export class RecentUserProjectionComponent 
    implements OnInit, OnDestroy {
    formApi : DwMetaDataFormApi;
    projection : WcUserProjectionEntity;

    constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
                @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
                private dwFormStateService: DwMetaDataFormStateService) 
    {
        this.formApi = dwFormStateService.state.formApi;
    }
    getRoUserProjections(userId? : number, year? : number) : Observable<RoUserProjectionAnalyzedEntity[]>{
        if (userId == undefined || year == undefined)
            return of(null); 
        const md = new AppMetaDataService();
        const query = md.RoUserProjectionAnalyzed.CreateQuery();

        const qh = new DwQueryHelper();

        const fg = new DwQueryFilterGroup();
        fg.Op = DwOperator.And;
        fg.AddFilterAnd(qh.filters.Equal(md.RoUserProjectionAnalyzed.UserId, userId));
        fg.AddFilterAnd(qh.filters.Equal(md.RoUserProjectionAnalyzed.FiscalYear, year));
        query.AddFilterAnd(fg);
        
        const sort = new DwQueryOrder();
        sort.IsAscending = false;
        sort.Field = new DwQueryFieldInfo();
        sort.Field.FullFieldName = md.RoUserProjectionAnalyzed.DateTimeProjected;
        query.OrderBy(sort);
        return this.dataService.executeQuery(query);
    }
    subscriptions: Subscription[] = [];
    userId?: number;
    fiscal? : number;
    next? : RoUserProjectionAnalyzedEntity;
    projections? : RoUserProjectionAnalyzedEntity[] = [];
    ngOnInit(): void {
        this.subscriptions.push(
            this.formApi.getFormDataChanges().subscribe(state => {
                    this.projection = this.formApi.getFormData();
                    if (this.projection.Ethos_UserId != this.userId || this.projection.FiscalYear != this.fiscal){
                        this.fiscal = this.projection.FiscalYear;
                        this.userId = this.projection.Ethos_UserId;
                        this.projections = [];
                    }
                    this.getRoUserProjections(this.userId, this.fiscal)
                        .subscribe(p =>{
                                if (p.length > 0) this.next = p[0] ?? this.next;
                                this.projections = p;
                                this.projections?.forEach(p => {
                                    if (p.Revenue > 0 && p.Cost > 0){
                                        p.Gross = p.Revenue - p.Cost;
                                        p.GrossMargin = 100 * (p.Gross / p.Revenue);
                                    }
                                });
                        });
                })
            );
      }
      ngOnDestroy(): void {
        for(const subscription of this.subscriptions) {
          subscription.unsubscribe();
        }
      }
}
